import { render } from "./batchProductOffer.vue?vue&type=template&id=6b5e97be&scoped=true"
import script from "./batchProductOffer.vue?vue&type=script&lang=js"
export * from "./batchProductOffer.vue?vue&type=script&lang=js"

import "./batchProductOffer.vue?vue&type=style&index=0&id=6b5e97be&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5e97be"]])

export default __exports__